import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { UserDataPayload, UserDataResponse } from "@/types/interface/user";

export const useUserStore = defineStore("userStore", () => {
  const user = ref<UserDataResponse>();
  const users = ref<UserDataResponse[]>([]);

  function initUsers(data: any) {
    users.value = data?.data;
  }

  function addNewUser(data: any) {
    user.value = data;
  }

  async function dispatchGetUsers(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.user.getUser(page, limit, queryParam);
      if (status === 200 ) {
        initUsers(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idUser = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.user.findUser(idUser);
      if (status === 200 ) {
        addNewUser(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: UserDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.user.createUser(payload);
      if (status === 200 ) {
        addNewUser(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idUser = "", payload: UserDataPayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.user.updateUser(idUser, payload);
      if (status === 200 ) {
        addNewUser(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idUser = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.user.deleteUser(idUser);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    user,
    users,
    initUsers,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetUsers,
    dispatchDelete
  };
});